var React = require('react');
var EndFrame = require('../_common/EndFrame');

var Texts = require('../../../data/texts.json');

var EndFrameOligarchie = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object
    },

    getDefaultProps: function()
    {
        return {
            titleObjectKey: 'oligarchieTitle',
            storySubtitle: Texts.scenes.oligarchie.subtitle,
            bottomTile: true,
            bottomTileColor: 'beige',
        }
    },

    render: function()
    {
        return (
            <EndFrame
                { ...this.props}
            />
        );
    }

});

module.exports = EndFrameOligarchie;



// WEBPACK FOOTER //
// ./js/components/frames/E-Oligarchie/8-EndFrame.jsx